/**
 * DiscoveryPanel Component
 * Right panel for track discovery, recommendations, and search
 */
import { Compass, ChevronRight } from 'lucide-react';
import { useUIStore } from '../../stores/ui';
import { TabSwitcher } from '../discovery/TabSwitcher';
import { SearchPanel } from '../discovery/SearchPanel';
import { RecsPanel } from '../discovery/RecsPanel';
import { SecondaryPlaylist } from '../discovery/SecondaryPlaylist';

export function DiscoveryPanel() {
  const { discoveryPanelOpen, toggleDiscoveryPanel, rightPanelTab } = useUIStore();

  return (
    <>
      {/* Panel */}
      <aside
        className={`
          transition-all duration-300 ease-in-out border-l border-zinc-800 bg-zinc-900 flex flex-col
          ${discoveryPanelOpen ? 'w-96' : 'w-0'}
        `}
        aria-hidden={!discoveryPanelOpen}
      >
        {discoveryPanelOpen && (
          <>
            {/* Header */}
            <div className="p-4 border-b border-zinc-800 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Compass className="w-5 h-5 text-emerald-500" />
                <h2 className="text-lg font-semibold text-zinc-100">Discovery</h2>
              </div>

              <button
                onClick={toggleDiscoveryPanel}
                className="p-1.5 rounded-md text-zinc-400 hover:text-zinc-100 hover:bg-zinc-800 transition-colors"
                aria-label="Close discovery panel"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>

            {/* Tab Switcher */}
            <TabSwitcher />

            {/* Tab Content */}
            <div className="flex-1 overflow-hidden">
              {rightPanelTab === 'search' && <SearchPanel />}
              {rightPanelTab === 'recs' && <RecsPanel />}
              {rightPanelTab === 'playlist' && <SecondaryPlaylist />}
            </div>
          </>
        )}
      </aside>

      {/* Floating Toggle Button (when panel is closed) */}
      {!discoveryPanelOpen && (
        <button
          onClick={toggleDiscoveryPanel}
          className="fixed right-0 top-1/2 -translate-y-1/2 bg-emerald-500 text-white p-2 rounded-l-lg shadow-lg hover:bg-emerald-600 transition-colors z-10"
          aria-label="Open discovery panel"
        >
          <Compass className="w-5 h-5" />
        </button>
      )}
    </>
  );
}
